/** @format */

const template = `
<sis-popover
  [disable-popover]="$ctrl.isPopoverDisabled($ctrl.searchParameter)"
  (hidden)="$ctrl.onHidden()"
  [is-open]="$ctrl.popoverIsOpen"
  [show-close-button]="false"
  [underline-trigger-text]="false"
  (shown)="$ctrl.onShown()">
  <div
    class="sis-popover-trigger-content tag"
    ng-class="{
         'search-string': $ctrl.searchParameter === 'searchString',
         'no-editing': $ctrl.searchParameter === 'searchString' || $ctrl.readOnly,
         'permanent': $ctrl.isPermanent
       }">
    <div class="tag-content">
      <div class="tag-title">
        <span>{{::'SEARCH.FILTER_TAGS.' + $ctrl.option.name | translate}}</span>
      </div>
      <div class="tag-description">
        <span>{{$ctrl.getParameterValue()}}</span
        ><!--
        --><span ng-if="$ctrl.isPermanent && $ctrl.getParameterValue().length === 0" translate>SEARCH.FILTER_TAGS.ANY</span>
      </div>
      <sis-icon [icon]="'edit'" [color]="'primary'" class="tag-content__pen-icon"></sis-icon> </div
    ><!--
 --><button
      type="button"
      class="link-button"
      ng-if="!$ctrl.isPermanent"
      ng-click="$ctrl.removeSelection({searchParameter: $ctrl.searchParameter}); $event.stopPropagation();"
      title="{{::'ARIA_LABEL.REMOVE_SEARCH_TEXT'|translate}}"
      aria-label="{{::'ARIA_LABEL.REMOVE_SEARCH_TEXT'|translate}}"
      data-cy="remove-search-filter">
      <sis-icon icon="close"></sis-icon>
    </button>
  </div>

  <search-filter
    class="sis-popover-popover-content"
    on-select="$ctrl.submitFilter({values, searchParameter: $ctrl.searchParameter})"
    option="$ctrl.option"
    parameter-model="$ctrl.parameterModel"
    popover-is-open="$ctrl.popoverIsOpen"
    search-again="$ctrl.searchAgain()"
    search-params="$ctrl.searchParams"
    university="$ctrl.university"></search-filter>
</sis-popover>
`;
export default template;
